import { useErrorHandling } from '@/composables'
import { ENDPOINTS } from '@/endpoints'
import type { APIResponse, ProductComparisonItem, ProductComparisonPriceItem } from '@/types'
import type { GenericAbortSignal } from 'axios'
import axios from 'axios'

export const getProductComparison = async (
    productCategoryKey: string,
    signal?: GenericAbortSignal,
) => {
    if (!productCategoryKey) return

    const request = axios.get<APIResponse<ProductComparisonItem[]>>(
        `${ENDPOINTS.PRODUCT_COMPARISON}`,
        {
            params: {
                productCategoryKey,
            },
            signal,

            // When a request is cancelled, we want to suppress the toast
            suppressToast: !!signal,
            paramsSerializer: {
                indexes: true,
            },
        },
    )
    const response = await useErrorHandling(request)

    return response.data.data
}

export const getProductComparisonProducts = async (
    productCategoryId: string,
    productKeys: number[],
    signal?: GenericAbortSignal,
) => {
    if (!productCategoryId) return

    const request = axios.get<APIResponse<ProductComparisonItem[]>>(
        `${ENDPOINTS.PRODUCT_COMPARISON}/products`,
        {
            params: {
                productCategoryId,
                productKeys
            },
            signal,

            // When a request is cancelled, we want to suppress the toast
            suppressToast: !!signal,
            paramsSerializer: {
                indexes: true,
            },
        },
    )
    const response = await useErrorHandling(request)

    return response.data.data
}

export const getProductComparisonPrice = async (productIds: number[], signal?: GenericAbortSignal) => {
    const request = axios.get<APIResponse<ProductComparisonPriceItem[]>>(
        `${ENDPOINTS.PRODUCT_COMPARISON}/price`,
        {
            params: {
                productIds,
            },
            signal,
            suppressToast: !!signal,
            paramsSerializer: {
                indexes: true,
            },
        },
    )
    const response = await useErrorHandling(request)

    return response.data.data
}
